import Vue from 'vue';
import {
    Message
} from 'element-ui';
Vue.prototype.$message = Message;

import router from '@/routes'
//引入组件对象,用来序列化对象
import Qs from 'qs';
//获取项目配置地址
const rootUrl = process.env.API_URL;
// 引用axios组件对象
const axios = require('axios');

const methodEnumArray = ["GET", "HEAD", "POST", "POSTNEW", "PUT", "PATCH", "DELETE", "OPTIONS", "TRACE"];

//在页面初始化,多个接口调用出现Session失效的情况下,只做一次登录跳转
var timeoutCount = 0;

/**
 * 统一的Axios请求接口
 *
 * @param method            (必填)             请求方式  GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS, TRACE
 * @param url               (必填)             请求的接口地址
 * @param requestParam      (选填,为空放NULL)   requestParam类型的参数对象(JSON对象)
 * @param requestBody       (选填,为空放NULL)   requestBody 封装的数据对象
 * @param headers           (选填,默认放NULL)   自定义请求头信息 , 一般情况下我们默认的headers 内容是如下内容
 *                                            { 'Content-Type': 'application/x-www-form-urlencode','X-Requested-With': 'XMLHttpRequest'}
 * @param    successCallBack                   函数回调  function(data){ ****** } //此处已经完全处理好包装结果的判定
 * @param    errorCallBack                     函数回调  function(){ ****** }     //出现错误需要回调的操作.可以不进行操作
 * @return   cannelSource          取消函数     可能有些地方需要使用,在多次请求下,数据覆盖的问题.
 *                                             需要停止的时候 cannelSource.cancel() 调用一下该函数就可以;
 *
 *                                             Attention:警告..关于后台POST类型数据请求的问题!. 后台接口参数定义不写任何注解声明!
 *                                             没有加@RequsetParam ,或者是@RequsetBody 注解,这就是一个十分让人棘手的问题了!因为这种情况,后台有两种映射方式.
 *                                             url '?' 问号拼接的也能映射,form data 数据格式也能映射成功.后台swagger接口扫描器针对这种,不加完整参数注解的 参数 就采用了 url 地址请求的格式.
 *                                             可是 url地址头拼接的时候,有长度限制. 因此我们还有大表单对象的话,针对上面这种情况,我们使用FROM_DATA 传参方式.
 *                                             axios在发送POST数据的时候,其实可以带上request param ; request payload ; 以及form data 三种格式.
 *                                             如果采用request payload 方式上传数据,其实是指定后台以 JSON 格式接收数据,那么后台这块一定已经添加上了注解@RequsetBody声明.
 *                                             在使用通用接口的时候,主要重新指定一下请求头为{ 'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest'},
 *                                             axios data参数, 直接传递json对象就可以 . 如果是form data类型 ,
 *                                             我们需要{ 'Content-Type': 'application/x-www-form-urlencode','X-Requested-With': 'XMLHttpRequest'}这种头声明.
 *                                             同时data 数据(为防止叫法混淆,我们默认是指的我们传递的参数requestBody)必须要qs转化. 为了应对后台接口多种不规范出现的问题.请使用者注意.
 *                                             为了不扩展我们统一请求接口的入参数量,我这里会根据headers自动判断是否能需要qs的转化,好像必须带入自定义的头对象,无法使用补全的头声明,不知道是不是vue本身或者axios本身的bug.
 *
 */
function getMessageByAxios(method, url, requestParam, requestBody, headers, successCallBack, errorCallBack, mobileMes = true) {
    if (strIsBlank(method) || ($.inArray(method.toLocaleUpperCase(), methodEnumArray) === -1)) {
        console.error("请求方法类型不能为空");
        return null;
    }
    if (strIsBlank(url)) {
        console.error("请求地址不能为空");
        return null;
    }
    //存在,但不是对象类型
    if (headers && !(typeof headers === 'object')) {
        console.error("自定义请求头不合符规范");
        return null;
    } else if (!headers) {
        //默认带上ajax请求头格式.
        headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    //    let code =Vue.prototype.$util.UUID();
    //    if (requestParam) {
    //        requestParam = filterNull(requestParam);
    //        requestParam.RandomCode=code;
    //    }else{
    //        requestParam={'RandomCode':code};
    //    }
    if (requestBody) {
        requestBody = filterNull(requestBody);
    }
    if (headers) {
        var ct = headers['Content-Type'];
        var patt1 = new RegExp('application/x-www-form-urlencoded');
        if (patt1.test(ct)) {
            if (requestBody) {
                requestBody = Qs.stringify(requestBody);
            }
        }
    }
    //生成请求停止令牌,对当前请求
    let CancelToken = axios.CancelToken;
    //绑定阻断请求对象
    let cannelSource = CancelToken.source();
    //发送请求
    axios({
        headers: headers,
        method: method,
        url: url,
        timeout: 30000, //默认10秒钟超时,防止过长时间等待
        params: requestParam ? requestParam : null,
        //只有POST 与 PUT 请求才出现 body 体数据 ,其他类型的不采用这种方式
        data: (method.toLocaleUpperCase() === "POST" || method.toLocaleUpperCase() === "PUT") ? requestBody : null,
        baseURL: rootUrl,
        withCredentials: true,
        //阻断请求
        cancelToken: cannelSource.token
    }).then(function (res) {
        if (res.data.status === 0) {
            successCallBack(res.data.data ? res.data.data : res.data);
        } else if (res.data.code === 'ILLEGAL_SESSION') {
            if (timeoutCount === 0) {
                timeoutCount++;
                router.push({
                    path: "/login",
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                });
            }
        } else {

            if (errorCallBack) {
                if (mobileMes) {
                    Vue.prototype.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
                errorCallBack(res.data.message);
            } else {
                Vue.prototype.$message({
                    type: 'error',
                    message: res.data.message
                });
            }
        }
    }).catch(function (thrown) {
        //请求被中断了
        if (thrown) {
            if (axios.isCancel(thrown)) {
                console.error('请求被取消了:', thrown.message);
                if (errorCallBack) {
                    errorCallBack(true);
                }
            } else {
                console.error('调用接口失败了:', thrown.message);
                if (errorCallBack) {
                    errorCallBack(true);
                }
            }
        }
    });
    //在使用之前 一定要判断一下 ,调用是否已经初始化该函数,否则可能报错.
    return cannelSource;
}

function getMessageByAxios1(method, url, requestParam, requestBody, headers, successCallBack, errorCallBack) {
    if (strIsBlank(method) || ($.inArray(method.toLocaleUpperCase(), methodEnumArray) === -1)) {
        console.error("请求方法类型不能为空");
        return null;
    }
    if (strIsBlank(url)) {
        console.error("请求地址不能为空");
        return null;
    }
    //存在,但不是对象类型
    if (headers && !(typeof headers === 'object')) {
        console.error("自定义请求头不合符规范");
        return null;
    } else if (!headers) {
        //默认带上ajax请求头格式.
        headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    let code = Vue.prototype.$util.UUID();
    if (requestParam) {
        requestParam = filterNull(requestParam);
        requestParam.RandomCode = code;
    } else {
        requestParam = {
            'RandomCode': code
        };
    }
    if (requestBody) {
        requestBody = filterNull(requestBody);
    }
    if (headers) {
        var ct = headers['Content-Type'];
        var patt1 = new RegExp('application/json');
        if (patt1.test(ct)) {
            if (requestBody) {
                requestBody = Qs.stringify(requestBody);
            }
        }
    }
    //生成请求停止令牌,对当前请求
    let CancelToken = axios.CancelToken;
    //绑定阻断请求对象
    let cannelSource = CancelToken.source();
    //发送请求
    axios({
        headers: headers,
        method: method,
        url: url,
        timeout: 10000, //默认10秒钟超时,防止过长时间等待
        params: requestParam ? requestParam : null,
        //只有POST 与 PUT 请求才出现 body 体数据 ,其他类型的不采用这种方式
        data: (method.toLocaleUpperCase() === "POST" || method.toLocaleUpperCase() === "PUT") ? requestBody : null,
        baseURL: rootUrl, //
        withCredentials: true,
        //阻断请求
        cancelToken: cannelSource.token
    }).then(function (res) {
        if (res.data.code === 'SUCCESS') {
            successCallBack(res.data.data ? res.data.data : res.data);
        } else if (res.data.code === 'ILLEGAL_SESSION') {
            if (timeoutCount === 0) {
                timeoutCount++;
                router.push({
                    path: "/login",
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                });
            }
        } else {
            if (errorCallBack) {
                Vue.prototype.$message({
                    type: 'error',
                    message: res.data.message
                });
                errorCallBack(res.data.message);
            } else {
                Vue.prototype.$message({
                    type: 'error',
                    message: res.data.message
                });
            }
        }
    }).catch(function (thrown) {
        //请求被中断了
        if (thrown) {
            if (axios.isCancel(thrown)) {
                console.error('请求被取消了:', thrown.message);
                if (errorCallBack) {
                    errorCallBack(true);
                }
            } else {
                console.error('调用接口失败了:', thrown.message);
                if (errorCallBack) {
                    errorCallBack(true);
                }
            }
        }
    });
    //在使用之前 一定要判断一下 ,调用是否已经初始化该函数,否则可能报错.
    return cannelSource;
}

/**
 * 字符串对象是否为空
 * @param str
 * @returns
 */
function strIsBlank(str) {
    if (!str || $.trim(str) === "") {
        return true;
    }
    return false;
}

/**
 * 获取对象类型
 * @param obj
 * @returns {string}
 */
function getObjectType(obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

/**
 * 空属性过滤
 * @param o
 * @returns {*}
 */
function filterNull(o) {
    if (o) {
        if (typeof o === 'object') {
            for (let key in o) {
                if (o[key] == null) {
                    delete o[key];
                }
                if (getObjectType(o[key]) === 'string') {
                    o[key] = o[key].trim()
                } else if (getObjectType(o[key]) === 'object') {
                    o[key] = filterNull(o[key])
                } else if (getObjectType(o[key]) === 'array') {
                    o[key] = filterNull(o[key])
                }
            }
        }
    }
    return o
}

/**
 * 对象深层属性JSON转换
 * @param obj
 * @returns {*}
 */
function jsonProp(obj) {
    if (!obj || (typeof obj !== 'object')) {
        return obj
    }
    Object.keys(obj).forEach((key) => {
        if ((typeof obj[key]) === 'object') {
            obj[key] = JSON.stringify(obj[key])
        }
    });
    return obj
}
/**
 *返回VUE模板对象
 */
export default {
    getMessageByAxios: function (method, url, requestParam, requestBody, headers, successCallBack, errorCallBack, mobileMes) {
        return getMessageByAxios(method, url, requestParam, requestBody, headers, successCallBack, errorCallBack, mobileMes);
    },
    getMessageByAxios1: function (method, url, requestParam, requestBody, headers, successCallBack, errorCallBack) {
        return getMessageByAxios1(method, url, requestParam, requestBody, headers, successCallBack, errorCallBack);
    },
    post: function (url, requestBody, successCallBack, errorCallBack) {
        return getMessageByAxios("POST", url, null, requestBody, null, successCallBack, errorCallBack);
    },
    postNew: function (url, requestBody, successCallBack, errorCallBack) {
        return getMessageByAxios1("POST", url, null, requestBody, null, successCallBack, errorCallBack);
    },
    // postNew: function (url,requestParam,requestBody,headers,successCallBack,errorCallBack) {
    //     return getMessageByAxios1("POST",url,requestParam,requestBody,headers,successCallBack,errorCallBack);
    // },
    get: function (url, requestParam, successCallBack, errorCallBack) {
        return getMessageByAxios("GET", url, requestParam, null, null, successCallBack, errorCallBack);
    }
}


// WEBPACK FOOTER //
// ./src/js/axiosPackag.js